import React from 'react'
import jwtDecode from 'jwt-decode'
import { getToken } from '../../../lib/storage'

import { PLAYBACK_ERRORS } from '../../../constants'
import { ErrorHandlerModal, BCErrorHandlerModal } from './modal'
import { segmentTrackBCPlayerError } from '../../../segment/segment-track'

class ErrorHandler extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      hasError: false,
      hasBCPlayerError: false
    }

    this.onBCPlayerError = () => {
      this.setState({ hasBCPlayerError: true })
    }
  }

  componentDidCatch(error) {
    if (error.graphQLErrors) {
      const currentError = error.graphQLErrors[0]
      if (PLAYBACK_ERRORS.includes(currentError.code)) {
        this.setState({ hasError: true, errorMsg: currentError.message })
      }
      return
    }

    if (error.name === 'Error') {
      this.setState({ hasError: true, errorMsg: error.message })
    }
  }

  render() {
    const { children } = this.props
    const tokenFromLocalStorage = getToken()
    const decoded = tokenFromLocalStorage && jwtDecode(tokenFromLocalStorage)

    // Tracking BC Player errors in segment to monitor their frequency and impact.
    if (this.state.hasBCPlayerError) {
      segmentTrackBCPlayerError({
        deviceId: decoded.deviceId
      })
      return <BCErrorHandlerModal />
    }

    if (this.state.hasError) {
      return <ErrorHandlerModal message={this.state.errorMsg} />
    }

    return children(this.onBCPlayerError)
  }
}

export default ErrorHandler
